<template>
  <span>
    <Tooltip
      :theme="theme"
      :max-width="maxWidth"
      :content="content"
      :placement="placement"
      :transfer="transfer"
    >
      <Icon
        :size="size"
        :type="iconType"
        :style="{ color: color }"
      />
    </Tooltip>
  </span>
</template>

<script>
export default {
  name: 'Prompt',
  props: {
    iconType: {
      type: String,
      default: 'md-information-circle'
    },
    size: {
      type: Number,
      default: () => 18
    },
    content: {
      type: String,
      required: true
    },
    maxWidth: {
      type: Number,
      default: () => 400
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    color: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      default: 'dark'
    },
    transfer: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
</style>
